import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { scrollToId } from "./Reveal";

export default function StickyJoinBar() {
  const [pastHero, setPastHero] = useState(false);
  const [formVisible, setFormVisible] = useState(false);

  useEffect(() => {
    const hero = document.getElementById("hero");
    const forms = document.querySelectorAll("#register, [data-testid='final-cta-banner']");
    const heroObs = new IntersectionObserver(([e]) => setPastHero(!e.isIntersecting), { threshold: 0.15 });
    const formObs = new IntersectionObserver((entries) => setFormVisible(entries.some((e) => e.isIntersecting)), { threshold: 0.1 });
    if (hero) heroObs.observe(hero);
    forms.forEach((f) => formObs.observe(f));
    return () => { heroObs.disconnect(); formObs.disconnect(); };
  }, []);

  const show = pastHero && !formVisible;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="sticky-join-bar"
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="md:hidden fixed bottom-0 left-0 right-0 z-40 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]"
        >
          <div className="flex items-center justify-between gap-3 rounded-2xl bg-[#0B0B12]/95 backdrop-blur-md border border-[#A89DE3]/25 shadow-2xl shadow-black/30 pl-4 pr-2 py-2">
            <div className="min-w-0">
              <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-[#A89DE3] truncate">Free · Sept 28 – Oct 11</p>
              <p className="font-display font-extrabold text-[#FFFFFF] text-sm leading-tight truncate">14-Day Metabolic Reset</p>
            </div>
            <button
              data-testid="sticky-join-button"
              onClick={() => scrollToId("register")}
              className="shrink-0 rounded-full bg-[#1B2FD8] text-[#FFFFFF] px-5 py-3 font-display font-extrabold text-sm tracking-wide active:scale-95 transition-transform"
            >
              I'M IN – Join FREE
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
